import React from 'react';
import { Icon } from '@phosphor-icons/react';

interface Props {
  Icon: Icon;
  num: number;
  description: string;
}

const AchievementBadge: React.FC<Props> = (props) => {
  const { Icon, num, description } = props;

  return (
    <div className="w-20 flex flex-col gap-1">
      <div className="relative w-full aspect-square flex items-center justify-center bg-secondary rounded-full">
        <Icon
          weight="fill"
          size="3.5rem"
          color="white"
          className="absolute top-2.5"
        />

        <div className="absolute bottom-2 w-6 aspect-square flex items-center justify-center text-md font-bold leading-none text-white bg-secondary rounded-full">
          {num}
        </div>
      </div>

      <div className="text-center text-sm font-semibold leading-tight">
        {description}
      </div>
    </div>
  );
};

export default AchievementBadge;
